/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';

import { first } from 'lodash';

import { ApprovedQuotesDialogConfig } from '../../resources/lead-details-business.service';
import { LeadApprovedQuote, NONE_APPROVED_QUOTE } from '../../resources/lead.model';

@Component({
  standalone: false,
  selector: 'gh-approved-quotes-dialog',
  templateUrl: 'approved-quotes-dialog.component.html',
  styleUrls: ['approved-quotes-dialog.component.scss'],
})
export class ApprovedQuotesDialogComponent implements OnInit, DialogInput<ApprovedQuotesDialogConfig> {
  input: ApprovedQuotesDialogConfig;

  quotes: LeadApprovedQuote[];
  selectedQuote?: LeadApprovedQuote;

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  get isSelected(): boolean {
    return isNotNil(this.selectedQuote);
  }

  ngOnInit(): void {
    const { quotes } = this.input;

    this.quotes = quotes;
    this.selectedQuote = first(quotes);
  }

  onOk(): void {
    this.dialogRef.close(this.selectedQuote || NONE_APPROVED_QUOTE);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const approvedQuotesDialogRoute = createDialogRoute({
  component: ApprovedQuotesDialogComponent,
  config: {
    autoFocus: false,
  },
});
